// Timezone-safe calendar-date helpers for the reservations grid.
//
// The grid is a Phuket (UTC+7) business view: every viewer, wherever they are, must see the same Bangkok
// business days and the totals that belong to them. Bugs arise when a calendar day is round-tripped through
// an absolute instant, because the same instant lands on different calendar days in different timezones.
// These helpers key/parse by calendar DATE only, so they are stable across the viewer's browser timezone.

// Format a Date's LOCAL calendar day as yyyy-MM-dd. Used to look up the server-supplied program-counter map
// (Onsite/Offsite + Programs/Fitness/Weight Loss), which the server keys the same way from a DateOnly. Each
// Syncfusion cell's `data-date` decodes to local midnight of the business day it displays, so the local
// Y/M/D is that business day.
export function programCounterKey(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

// Parse a plain yyyy-MM-dd calendar date (the server sends the Bangkok business date) into a LOCAL Date at
// midnight, so the grid's window anchors to that calendar day for viewers in ANY timezone. `new Date(ymd)`
// is deliberately NOT used: it parses yyyy-MM-dd as UTC midnight, which shifts to the previous day for
// viewers west of UTC.
export function parseLocalDate(ymd: string): Date {
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d);
}
